import React, { useState, useEffect, useCallback } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { DoughnutChart } from "gatsby-plugin-hfn-profile/components/Charts/index";
import axios from "axios";
import getMandatoryEnv from "../../../../../sites-common/utils/getMandatoryEnv";
import useCommonData from "../customeSection/useCommonData";

const OffersBlock = () => {
  const { kmcFormConfig } = getMandatoryEnv(["kmcFormConfig"]);
  const { getothers } = useCommonData();
  const [chatData, setChatDate] = useState([]);
  const allColors = [
    "#023B80",
    "#E82B82",
    "#2CBDF3",
    "#9F6ADB",
    "#2CAFC1",
    "#e6ad8f",
    "#dd6277",
    "#de78b5",
    "#8fe3ba",
    "#00FF00",
  ];

  const chatGetData = useCallback(() => {
    axios.get(`${kmcFormConfig.formUrl}/api/kmc/getstatistics`).then((res) => {
      const sd = res.data.data.filter((i) => {
        return i.chart_no !== "" && i.item_count !== "" && i.item !== "";
      });
      setChatDate(sd);
    });
  }, [kmcFormConfig.formUrl]);

  const groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  };
  const result = groupBy(chatData, "chart_no");

  useEffect(() => {
    chatGetData();
  }, [chatGetData]);

  return (
    <>
      <div className="row justify-content-center pb-2">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <h2>Activities</h2>
        </div>
      </div>
      <div className="row justify-content-center pt-4 pb-4">
        <div className="col-sm-12 col-md-6 col-lg-6 pt-6 mt-4">
          <StaticImage
            className="healthImg"
            src="../../../assets/images/kmc-images/Offers/MaskGroup16.png"
            alt="Special Discounts on treatments"
          />
          <div className="health-Offers text-center">
            <h2>Treatment at Reasonable Cost</h2>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 pt-6 mt-4">
          <StaticImage
            className="healthImg"
            src="../../../assets/images/kmc-images/Offers/MaskGroup17.png"
            alt="Free Health Camps"
          />
          <div className="health-Offers text-center">
            <h2>Free Health Camps</h2>
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-12 col-sm-12 col-12">
          {getothers?.map((title) => {
            return (
              <>
                {title.type === "statistics_title" ? (
                  <h2>{title.message}</h2>
                ) : (
                  ""
                )}
              </>
            );
          })}
        </div>
      </div>
      <div className="row justify-content-center pt-0 pb-4">
        {Object.keys(result).map((key) => {
          const data = result[key].map((item) => {
            return item.item_count;
          });
          const graphItems = result[key].map((item) => {
            return { itemCount: item.item_count, itemList: item.item };
          });
          const dataItems = result[key].map((item) => {
            return item.chart_title;
          });
          // .join(", ");

          return (
            <>
              <div className="col-sm-12 col-md-12 col-lg-4 mt-4">
                <div className="graphImg">
                  <div className="App">
                    <div className="chartContainer">
                      <DoughnutChart
                        enableTooltip
                        showLegend
                        borderWidth={0.9}
                        sectorData={data}
                        showLabelBackdrop={false}
                        // width={500}
                        legendPosition="bottom"
                        sectorColor={allColors}
                      />
                      <div className="chartInner">
                        <div className="chartStatus">{dataItems}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row mt-4">
                    {graphItems.map((i, index) => {
                      return (
                        <div className="col-md-6">
                          <p className="checkbox_items">
                            <span
                              style={{
                                backgroundColor: allColors[index],

                                padding: "2px 10px 2px 10px",

                                marginRight: "8px",
                              }}
                            />
                            {i.itemCount} {i.itemList}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default OffersBlock;
